import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { Creators as TermsOfUseCreators } from '../../store/ducks/termsOfUse';
import Loading from '../../components/Loading';

class TermosDeUso extends Component {
  static propTypes = {
    getTermsOfUseRequest: PropTypes.func.isRequired,
    termsOfUse: PropTypes.string.isRequired,
  };

  componentWillMount() {
    this.props.getTermsOfUseRequest();
  }

  render() {
    if (this.props.termsOfUse.loading) {
      return <Loading />;
    }

    return (
      <Fragment>
        <div
          className="text-box text-justify"
          dangerouslySetInnerHTML={{ __html: this.props.termsOfUse.terms_of_use }}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  termsOfUse: state.termsOfUse,
});

const mapDispatchToProps = dispatch => bindActionCreators(TermsOfUseCreators, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TermosDeUso);



// WEBPACK FOOTER //
// ./src/pages/termosDeUso/index.js